import { PROJECT_DETAILS } from "./data/projects";
import { BLOG_POSTS } from "./data/blog";

export const SITE = "https://nexastudioindia.com";
export const DEFAULT_DESC =
  "Nexa Studio is a brand building, advertising and performance marketing agency in Kolkata. Branding, social, content, podcasts, ad films, design and websites.";
export const DEFAULT_OG_IMAGE = `${SITE}/og-image.png`;

export const ROUTE_META = {
  "/": { t: "Brand Building & Digital Marketing Agency Kolkata | Nexa", d: DEFAULT_DESC },
  "/work": { t: "The 12 Year Ledger: Our Work | Nexa Studio", d: "FIFA U-17 World Cup, IPL, Vairagi Beer, Jewelbox and 100+ more brands built by the team behind Nexa Studio." },
  "/services": { t: "Services: Branding, Marketing, Ad Films | Nexa Studio", d: "Seven services under one roof in Kolkata: brand building, social media, performance marketing, content, podcasts, ad films and design." },
  "/studio": { t: "The Studio: Our Kolkata Team | Nexa Studio", d: "Meet the in house team, shoot floor and crew behind Nexa Studio, a brand building and content studio in Kolkata." },
  "/philosophy": { t: "Our Philosophy: Six Rules for Bold Brands | Nexa Studio", d: "Attention is the only currency. Read the six chapters behind how Nexa Studio builds brands that refuse to be ignored." },
  "/case-studies": { t: "Brand Case Studies from Kolkata | Nexa Studio", d: "How we built brands in sports, FMCG, beverages and real estate. The brief, the work and what it moved." },
  "/blog": { t: "Journal: Branding & Marketing, Kolkata | Nexa Studio", d: "Practical writing on brand building, performance marketing, content and the creative industry in Eastern India." },
  "/about": { t: "About Nexa Studio: Founders, Story, Myndroot", d: "Nexa Studio is led by Indira Mukherjee and Ankit Bhattacharyya, born from twelve years of Myndroot's work in Kolkata." },
  "/contact": { t: "Contact Nexa Studio | Brand Agency, Kolkata", d: "Got a brand that needs teeth? Reach Nexa Studio at 29 P.C Ghosh Road, Kolkata 700048, or call 98313 66263." },
};

const NOT_FOUND_META = {
  t: "Page Not Found | Nexa Studio",
  d: "That page never made it out of the den. Browse the work, services and journal of Nexa Studio, Kolkata.",
};

// Single source of truth for per-route head metadata (title, description,
// canonical, Open Graph, JSON-LD). Used by the client-side RouteMeta
// component and by the build-time prerender script.
export const getRouteMeta = (rawPathname) => {
  const pathname = rawPathname.length > 1 ? rawPathname.replace(/\/+$/, "") : rawPathname;
  let m = ROUTE_META[pathname];
  let jsonLd = null;
  let ogImage = DEFAULT_OG_IMAGE;
  let noindex = false;
  const workMatch = pathname.match(/^\/work\/(\d+)$/);
  const blogMatch = pathname.match(/^\/blog\/([\w-]+)$/);
  if (workMatch) {
    const p = PROJECT_DETAILS.find((x) => x.id === workMatch[1]);
    if (p) {
      m = { t: `${p.name} — Case File | Nexa Studio`, d: p.story.slice(0, 155) };
      ogImage = SITE + p.img;
      jsonLd = {
        "@context": "https://schema.org",
        "@type": "CreativeWork",
        name: p.name,
        image: SITE + p.img,
        about: p.sector,
        ...(p.year ? { dateCreated: p.year } : {}),
        creator: { "@id": `${SITE}/#organization` },
      };
    }
  } else if (blogMatch) {
    const p = BLOG_POSTS.find((x) => x.slug === blogMatch[1]);
    if (p) {
      m = { t: p.seoTitle || `${p.title} | Nexa Studio Field Notes`, d: p.excerpt };
      jsonLd = {
        "@context": "https://schema.org",
        "@type": "Article",
        headline: p.title,
        description: p.excerpt,
        datePublished: p.date,
        author: { "@id": `${SITE}/#organization` },
        publisher: { "@id": `${SITE}/#organization` },
        mainEntityOfPage: SITE + pathname,
      };
    }
  }
  if (!m) {
    m = NOT_FOUND_META;
    noindex = true;
  }
  return { title: m.t, description: m.d, canonical: SITE + pathname, ogImage, jsonLd, noindex };
};
